import { FaPaperPlane } from "react-icons/fa";
import Ivr1st from "../../assets/product/ivr1.png";
import Ivr2nd from "../../assets/product/ivr2.png";
import Ivr3rd from "../../assets/product/ivr3.png";

const IvrWorking = () => {
  const steps = [
    {
      id: 1,
      title: "Hosted IVR (Cloud-based IVR)",
      description:
        "A cloud-based or hosted IVR system is managed off-site by a third-party provider. This eliminates the need for businesses to invest in on-premise infrastructure and allows for easier scalability. Hosted IVR is popular among businesses that need flexible, cost-effective solutions.",
      image: Ivr1st,
      color: "bg-pink",
    },
    {
      id: 2,
      title: "On-premise IVR",
      description:
        "On-premise IVR solutions are installed within a company’s infrastructure. These solutions provide more control and customization options but come with higher upfront costs and maintenance requirements.",
      image: Ivr2nd,
      color: "bg-blue-900",
    },
    {
      id: 3,
      title: " Automated IVR",
      description:
        "An automated IVR system operates without human intervention, automating the entire call process. It includes routine customer service interactions like checking balances or processing payments.",
      image: Ivr3rd,
      color: "bg-pink",
    },
  ];
  return (
    <div className="w-full bg-white py-16 px-4 sm:px-6 lg:px-20">
      <div className="text-center mb-12">
        {/* <h2 className="text-pink font-semibold tracking-wider uppercase text-sm relative inline-block after:absolute after:w-full after:h-[2px] after:bg-pink-500 after:left-0 after:-bottom-1 after:rounded-full after:opacity-40">
          Types of Ivr
        </h2> */}

        <div className="text-center mt-4">
          <h1 className="md:text-4xl text-3xl font-bold text-gray-800">
            Types of IVR Solution
          </h1>
          <div className="mt-2 md:w-40 w-20 h-1 bg-pink mx-auto rounded"></div>
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto">
        {/* Dashed Curve Line */}
        <svg
          className="absolute left-0 top-1/3 -translate-y-1/2 w-full hidden sm:block"
          height="120"
          viewBox="0 0 1000 120"
          preserveAspectRatio="none"
        >
          <path
            d="M0,60 C250,0 750,120 1000,60"
            stroke="#E5E7EB"
            strokeWidth="2"
            strokeDasharray="10,10"
            fill="none"
          />
        </svg>

        {/* Paper Plane */}
        <FaPaperPlane className="hidden sm:block absolute right-0 top-[35%] transform translate-x-8 -translate-y-6 text-pink text-2xl rotate-12" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-y-12 sm:gap-y-0">
          {steps.map((step) => (
            <div
              key={step.id}
              className="flex flex-col items-center cursor-pointer text-center max-w-xs mx-auto hover:scale-105 transition-transform duration-300"
            >
              <div className="relative mb-4 w-36 h-36 rounded-full shadow-lg overflow-hidden">
                <img
                  src={step.image}
                  alt={step.title}
                  className="w-full h-full  object-cover  "
                />
                <div
                  className={`absolute bottom-2 right-4 w-9 h-9 ${step.color} text-white text-sm font-bold rounded-full flex items-center justify-center shadow-md border-2 border-white`}
                >
                  {String(step.id).padStart(2, "0")}
                </div>
              </div>

              <h3 className="text-lg font-semibold text-gray-700 mb-1">
                {step.title}
              </h3>
              <p className="text-gray-500 text-sm">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IvrWorking;

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// // import { faCalendar } from "@fortawesome/free-solid-svg-icons";
// // const experiences = [
// //   {
// //     role: "React Developer",
// //     company: "DeetyaSoft Pvt. Ltd.",
// //     achievements: [
// //       "React Development for Web Applications.",
// //       "Tailwind CSS for modern, responsive designs.",
// //       "API Integration and full-stack development tasks.",
// //       "Collaborating on end-to-end web development projects.",
// //     ],
// //     side: "right",
// //   },
// //   {
// //     role: " Web Developer",
// //     company: "4STEPS Digital Consulting",

// //     achievements: [
// //       "Frontend Development: Expertise in HTML, CSS, JavaScript, and modern frameworks like React and Next.js.",
// //       "Backend Development: Proficiency in Node.js and database management using MongoDB.",
// //       "APIs & Integrations: Familiarity with RESTful APIs and third-party integrations (payment gateways, social logins).",
// //       "Version Control: Experience with Git and GitHub for collaboration and code management.",
// //     ],
// //     side: "left",
// //   },
// //   {
// //     role: " Web Developer",
// //     company: "4STEPS Digital Consulting",

// //     achievements: [
// //       "Frontend Development: Expertise in HTML, CSS, JavaScript, and modern frameworks like React and Next.js.",
// //       "Backend Development: Proficiency in Node.js and database management using MongoDB.",
// //       "APIs & Integrations: Familiarity with RESTful APIs and third-party integrations (payment gateways, social logins).",
// //       "Version Control: Experience with Git and GitHub for collaboration and code management.",
// //     ],
// //     side: "right",
// //   },
// //   {
// //     role: " Web Developer",
// //     company: "4STEPS Digital Consulting",

// //     achievements: [
// //       "Frontend Development: Expertise in HTML, CSS, JavaScript, and modern frameworks like React and Next.js.",
// //       "Backend Development: Proficiency in Node.js and database management using MongoDB.",
// //       "APIs & Integrations: Familiarity with RESTful APIs and third-party integrations (payment gateways, social logins).",
// //       "Version Control: Experience with Git and GitHub for collaboration and code management.",
// //     ],
// //     side: "left",
// //   },
// // ];

// import {
//   faPhoneVolume,
//   faKeyboard,
//   faMicrophone,
//   faHeadset,
//   faPhoneSlash,
// } from "@fortawesome/free-solid-svg-icons";

// const steps = [
//   {
//     id: 1,
//     title: "Call Initiation",
//     icon: faPhoneVolume,
//     heading: "Call Initiation",
//     description: `A customer calls a business and is greeted by the IVR system, which plays a recorded greeting and presents options through voice prompts.`,
//     side: "right",
//   },
//   {
//     id: 2,
//     title: "Input from Customer",
//     icon: faKeyboard,
//     heading: "Input from Customer",
//     description: `The caller interacts with the system by pressing keys on their phone (Dual-Tone Multi-Frequency or DTMF) or speaking their choices if speech recognition is enabled.`,
//     side: "left",
//   },
//   {
//     id: 3,
//     title: "Processing Input",
//     icon: faMicrophone,
//     heading: "Processing Input",
//     description: `The IVR system processes the input (whether keypad selection or voice command) and determines the appropriate action, such as routing the call to the relevant department, providing requested information, or directing the customer to a live agent if needed.`,
//     side: "right",
//   },
//   {
//     id: 4,
//     title: "Completion or Further Interaction",
//     icon: faHeadset,
//     heading: "Completion or Further Interaction",
//     description: `The system either completes the transaction or continues interacting with the customer to gather further details. If necessary, the call is transferred to a live representative.`,

//     side: "left",
//   },
//   {
//     id: 5,
//     title: "End of Call",
//     icon: faPhoneSlash,
//     heading: "End of Call",
//     description: `Once the interaction is completed, the IVR system closes the call, either providing a summary of the service (e.g., a transaction confirmation) or ending with a message thanking the customer for their call.`,
//     side: "right",
//   },
// ];
// const IvrWorking = () => {
//   return (
//     <div className="bg-blue-50">
//       <section className="relative max-w-6xl mx-auto py-16 items-center text-main">
//         <h2 className="text-4xl font-bold text-center mb-4">How IVR Works?</h2>
//         <p className="text-center mb-10 text-gray-600">
//           A step-by-step overview of how our IVR system handles incoming calls
//           with efficiency and intelligence.
//         </p>

//         <div className="relative">
//           {/* Vertical Line (Hidden on Mobile) */}
//           <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-gradient-to-b from-cyan-500 via-green-500 to-pink-500"></div>

//           <div className="space-y-5">
//             {steps.map((step, idx) => (
//               <div
//                 key={idx}
//                 className={`relative flex ${
//                   step.side === "left" ? "justify-start" : "justify-end"
//                 } md:flex`}
//               >
//                 {/* Dot (Hidden on Mobile) */}
//                 <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2">
//                   <span className="w-6 h-6 bg-black border-4 border-cyan-500 rounded-full block"></span>
//                 </div>

//                 {/* Card */}
//                 <div
//                   className={`w-full max-w-md p-6 md:mx-0 mx-3 rounded-lg bg-white shadow-xl ${
//                     step.side === "left"
//                       ? "md:ml-20 md:text-left text-center"
//                       : "md:mr-20 md:text-left text-center"
//                   } mx-auto`}
//                 >
//                   {/* Icon and Heading */}
//                   <div className="flex items-center gap-3 justify-center md:justify-start mb-2">
//                     <div className="w-10 h-10 flex items-center justify-center rounded-full bg-cyan-100">
//                       <FontAwesomeIcon
//                         icon={step.icon}
//                         className="text-cyan-600 text-lg"
//                       />
//                     </div>
//                     <h3 className="text-main font-semibold text-[20px]">
//                       {step.heading}
//                     </h3>
//                   </div>

//                   {/* Description */}
//                   <div className="mt-2">
//                     <p className="text-gray-800 text-[15px] ">
//                       {step.description}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default IvrWorking;
